import { CustomGridColumns } from '../../CustomDataGrid';

export const CbenefColunm: CustomGridColumns[] = [
  {
    field: 'cod_beneficio_fiscal',
    headerName: 'Cód. Benefício Fiscal',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
];
